import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";

export const TEAM_MEMBER_APIS = {
  uploadFile: (params: any) => postRequest("/file/upload", params),
  getTeamMembers: (params: any) => getRequest("/team", params),
  addCreateTeamMember: (body: any) => postRequest(`/team`, body),
  editTeamMember: (id: number, params:any) => putRequest(`/team/${id}`, params),
  getTeamMemberByID: (id: number ) => getRequest(`/team/${id}`),
  addAvailableSlots: (body: any, params:any) => postRequest(`/team/add-available-slots`, body, params),
  getAvailableSlotsByID: (params: any) => getRequest(`/team/available/slots`,params),
  getAllRolePermissions: () => getRequest(`/role-permissions`),
  addRolePermission: (body: any) => postRequest(`/role-permissions`, body),
  editRole: (id: number, body:any) => putRequest(`/role-permissions/roles/${id}`, body),
  getRoles: (params: any) => getRequest("/role-permissions/roles", params),
  getRoleByID: (params:any ) => getRequest(`/role-permissions/roles`, params),
  toggleRole: (userId: number) => patchRequest(`/role-permissions/${userId}`, {}),






  activateMember: (userId: number) => patchRequest(`users/${userId}/enable`, {}),
  deactivateMember: (userId: number) =>patchRequest(`users/${userId}/disable`, {}),
};
